import api from './api';
import { buildUserPayload, type UserFormState, type UserRow } from '../constants/userManagement';

export async function getUserById(id: string): Promise<UserRow> {
  const res = await api.get(`/admin/users/${id}`);
  return res.data.data as UserRow;
}

export async function saveUser(form: UserFormState, editingId?: string) {
  const payload = buildUserPayload(form, !!editingId);
  if (editingId) {
    const res = await api.put(`/admin/users/${editingId}`, payload);
    return res.data.data;
  }
  const res = await api.post('/admin/users', payload);
  return res.data.data;
}

export async function listAdminRoles() {
  const res = await api.get('/admin/roles');
  return (res.data.data || []) as Array<{ _id: string; name: string; code?: string }>;
}

export function getApiErrorMessage(error: unknown, fallback = 'Something went wrong'): string {
  const err = error as { response?: { data?: { message?: string } }; message?: string };
  return err.response?.data?.message || err.message || fallback;
}
